/**
 * React Query Client Configuration
 */
import { QueryClient } from '@tanstack/react-query';

let queryClient: QueryClient | null = null;

/**
 * Get or create query client instance
 */
export const getQueryClient = (): QueryClient => {
  if (queryClient) {
    return queryClient;
  }

  queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: 0,
      },
    },
  });

  return queryClient;
};

/**
 * Reset query client (clear all cache)
 */
export const resetQueryClient = () => {
  if (queryClient) {
    queryClient.clear();
  }
};

